import React from 'react';
import Button from '../components/Button';
import Card from '../components/Card';
import CustomerCard from '../components/CustomerCard';
import LabelText from '../components/LabelText';
import Layout from '../components/layout/Layout';
import SplitSection from '../components/SplitSection';
import StatsBox from '../components/StatsBox';
import customerData from '../data/customer-data';
import HeroImage from '../svg/HeroImage';
import SvgCharts from '../svg/SvgCharts';
import { Helmet } from "react-helmet";
import favicon16 from "../images/favicon16.png";
import favicon32 from "../images/favicon32.png";
import favicon64 from "../images/favicon64.png";


export default () => (
  <Layout>
    <Helmet
      link={[
        { rel: "icon", type: "image/png", sizes: "16x16", href: `${favicon16}` },
        { rel: "icon", type: "image/png", sizes: "32x32", href: `${favicon32}` },
        { rel: "shortcut icon", type: "image/png", href: `${favicon64}` },
      ]}
    />
    <div className="application">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Sailsbib - Market Analysis Perspective</title>
        <link rel="canonical" href="http://sailsbib.com/" />
      </Helmet>
    </div>
    <section id="landing" className="pt-20 md:pt-40">
      <div className="container mx-auto px-8 lg:flex">
        <div className="text-center lg:text-left lg:w-1/2">
          <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold leading-none">
            Market Analysis Perspective
          </h1>
          <p className="text-xl lg:text-2xl mt-6 font-light">
            Analyzing the data to promote your business startup and generate leads for the
            offered services
          </p>
          <p className="mt-8 md:mt-12">
            <a className="text-sm" href="https://gmail.us11.list-manage.com/subscribe/post?u=dd812a45e89d08f7548d0c06c&amp;id=cdb1ecdc5b&amp;f_id=00f10fe1f0" target="_blank">
              <Button size="lg">Get Started</Button>
            </a>
          </p>
          <p className="mt-4 text-gray-600">
            Sales Win/Loss Analysis
          </p>
        </div>
        <div className="lg:w-1/2">
          <HeroImage />
        </div>
      </div>
    </section>
    <section id="features" className="py-20 lg:pb-40 lg:pt-48">
      <div className="container mx-auto text-center">
        <h2 className="text-3xl lg:text-5xl font-semibold">Main Concepts</h2>
        <div className="flex flex-col sm:flex-row sm:-mx-3 mt-12">
          <div className="flex-1 px-3">
            <Card className="mb-8">
              <p className="font-semibold text-xl">Targeted Experience</p>
              <p className="mt-4">
                Develop targeted campaigns that can be critical in winning contracts. Branding and outreach efforts is a critical element
              </p>
            </Card>
          </div>
          <div className="flex-1 px-3">
            <Card className="mb-8">
              <p className="font-semibold text-xl">Innovative Focus</p>
              <p className="mt-4">
                A criteria that target's a pre-existing concept which helps to ask some questions for solutions that meet new requirements
              </p>
            </Card>
          </div>
          <div className="flex-1 px-3">
            <Card className="mb-8">
              <p className="font-semibold text-xl">Experience Driven</p>
              <p className="mt-4">
                Marketing digital transformation, of commerce to Maximizing sales by delivering customer experiences
              </p>
            </Card>
          </div>
        </div>
      </div>
    </section>
    <SplitSection
      id="services"
      primarySlot={
        <div className="lg:pr-32 xl:pr-48">
          <h3 className="text-3xl font-semibold leading-tight">Market Analysis</h3>
          <p className="mt-8 text-xl font-light leading-relaxed">
            Our team of enthusiastic marketers will analyse and evaluate how your company stacks
            against the closest competitors
          </p>
        </div>
      }
      secondarySlot={<SvgCharts />}
    />
    <SplitSection
      reverseOrder
      primarySlot={
        <div className="lg:pl-32 xl:pl-48">
          <h3 className="text-3xl font-semibold leading-tight">
            Design And Plan Your Business Growth Steps
          </h3>
          <p className="mt-8 text-xl font-light leading-relaxed">
            Once the market analysis process is completed our staff will search for opportunities
            that are in reach
          </p>
        </div>
      }
      secondarySlot={<SvgCharts />}
    />
    <SplitSection
      primarySlot={
        <div className="lg:pr-32 xl:pr-48">
          <h3 className="text-3xl font-semibold leading-tight">
            Search For Performance Optimization
          </h3>
          <p className="mt-8 text-xl font-light leading-relaxed">
            With all the information in place you will be presented with an action plan that your
            company needs to follow
          </p>
        </div>
      }
      secondarySlot={<SvgCharts />}
    />
    <section id="stats" className="py-20 lg:pt-32">
      <div className="container mx-auto text-center">
        <LabelText className="text-gray-600">Our Customers Get Results</LabelText>
        <div className="flex flex-col sm:flex-row mt-8 lg:px-24">
          <div className="w-full sm:w-1/3">
            <StatsBox primaryText="+Growth" secondaryText="Key Information" />
          </div>
          <div className="w-full sm:w-1/3">
            <StatsBox primaryText="+Results" secondaryText="Relevant Conceptual " />
          </div>
          <div className="w-full sm:w-1/3">
            <StatsBox primaryText="+Sales" secondaryText="Raw Analytical Data" />
          </div>
        </div>
      </div>
    </section>
    <section id="testimonials" className="py-20 lg:py-40">
      <div className="container mx-auto">
        <LabelText className="mb-8 text-gray-600 text-center">The Statements From Our Prospects</LabelText>
        <div className="flex flex-col md:flex-row md:-mx-3">
          {customerData.map(customer => (
            <div key={customer.customerName} className="flex-1 px-3">
              <CustomerCard customer={customer} />
            </div>
          ))}
        </div>
      </div>
    </section>
    <section className="container mx-auto my-20 py-24 bg-gray-200 rounded-lg text-center">
      <h3 className="text-5xl font-semibold">Ready To Grow Your Business?</h3>
      <p className="mt-8 text-xl font-light">
        Integrated processes that will allow your business to scale logistics, and other essential metrics
      </p>
      <p className="mt-8">
        <a className="text-sm" href="https://gmail.us11.list-manage.com/subscribe/post?u=dd812a45e89d08f7548d0c06c&amp;id=cdb1ecdc5b&amp;f_id=00f10fe1f0" target="_blank">
          <Button size="xl">Get Started</Button>
        </a>
      </p>
    </section>
  </Layout>
);
